module.exports = __webpack_public_path__ + "entry-150bfe9b/background-0c2ff402b4db4d5c1aaf28e56d43c0be.svg";